import type { Tag } from 'app/network/listing';
import { useAllTags } from 'app/network/listing';

import { Column } from 'app/design/primitives/box';
import { useNavigation } from 'app/hooks/navigation';
import { TagPicker } from 'app/screens/new/components/tag-picker';

interface TagFilterProps {
  value: Tag['id'][];
  closeModal: () => void;
}

export function TagFilter({ value, closeModal }: TagFilterProps) {
  const navigation = useNavigation();

  const { data: tags } = useAllTags(false);

  const onPress = () => {
    // Can't show a modal when a bottomSheet is open; close it first, then open the tag picker
    closeModal();
    setTimeout(() => {
      navigation.navigate('tags', { goBackTo: 'set-atom-then-close', selectedTag: value[0] }, { pop: true });
    }, 300);
  };

  if (!tags && value.length > 0) return null;

  return (
    <Column width="100%">
      <TagPicker goBackTo="set-atom-then-close" onPress={onPress} selectedTagId={value[0]} />
    </Column>
  );
}
